module.exports = __webpack_public_path__ + "static/media/FleetLocate_LoginBanners_CamCoach.d7d4bcfa.jpg";